export const TOGGLE_LEFT_SIDEBAR = 'TOGGLE_LEFT_SIDEBAR';
export const OPEN_LEFT_SIDEBAR = 'OPEN_LEFT_SIDEBAR';
export const CLOSE_LEFT_SIDEBAR = 'CLOSE_LEFT_SIDEBAR';
